<!-- SK -->
<div *ngFor="let kodJazykIteracia of kodJazykIN.split(', '); let index = index;"
  [ngClass]="{'mt-2': index === 0}">

  <app-header-polozka
    *ngIf="!indexPolozkyVoFormulari || typZaznamuTextu.idSkupina"
    [typ]="typZaznamuTextu"
    [kodJazyk]="kodJazykIteracia"
    [formularFormGroup]="formularFormGroup"
    [zobrazitCopyButton]="index === 0 && kodJazykIN.length > 2">
  </app-header-polozka>

  <div *ngIf="typZaznamuTextu.opakovanie === 'A' || jeOpakovaniePodprogramu; else neopakovanaPolozka"
      formArrayName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}">

    <!-- SWAPOVACI BUTTON -->
    <div class="d-flex">
      <button *ngIf="indexPolozkyVoFormulari > 0"
        class="ms-auto"
        style="margin-top: -13px;"
        mat-icon-button
        type="button"
        (click)="vymenPolozky(indexPolozkyVoFormulari, kodJazykIteracia)"
        matTooltip="Vymeniť obsah položiek"
        aria-label="Vymeniť obsah položiek">
        <mat-icon>swap_vert</mat-icon>
      </button>
    </div>

    <div *ngIf="typZaznamuTextu.vazba === appStateService.VAZBA_STUPEN_TYP_STUDIA
        && index === 0"
      class="d-flex justify-content-end">

      <app-stupen-typ-studia
        [idTyp]="typZaznamuTextu.id"
        [poradieOpakovanejPolozky]="indexPolozkyVoFormulari+1">
      </app-stupen-typ-studia>

    </div>

    <div class="d-flex flex-row">

      <div *ngIf="typZaznamuTextu.opakovanie === 'A'" class="mt-3 me-2 h5">
        {{indexPolozkyVoFormulari + 1}}.
      </div>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label i18n>Zadajte text</mat-label>
        <input type="text"
              [placeholder]="getZadajteTextPlaceholder()"
              aria-label="Text"
              matInput
              [formControl]="mapaControlsovVJazykoch.get(kodJazykIteracia)"
              [matAutocomplete]="auto"
              [id]="getIdControlName(kodJazykIteracia)"
              [formControlName]="indexPolozkyVoFormulari"
              [name]="getIdControlName(kodJazykIteracia)"
              autocomplete="disabled">
          <button *ngIf="zobrazitClearButtonSK" type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="vymazObsahPolozky(kodJazykIteracia, indexPolozkyVoFormulari)"
              [matTooltip]="getZmazatTextTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of mapaFilteredOptionsVJazykoch.get(kodJazykIteracia) | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        <mat-hint i18n>min. 3 znaky pre filtrovanie položiek</mat-hint>
      </mat-form-field>

      <div *ngIf="somPoslednaOpakovanaPolozka
          && (typZaznamuTextu.opakovanie === 'A' || appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu))" class="mt-2 ms-2">
        <button mat-mini-fab color="primary" type="button" (click)="pridatPolozku(kodJazykIteracia)"
            [matTooltip]="getPridatPolozkuTooltip()"
            [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>add</mat-icon>
        </button>
      </div>

    </div>


    <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)
        && appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, indexPolozkyVoFormulari)"
      class="mb-3 font-italic"
      [ngClass]="{'ms-4': typZaznamuTextu.opakovanie === 'A', 'ms-1': typZaznamuTextu.opakovanie !== 'A'}">

      {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, indexPolozkyVoFormulari)}}
    </div>

    <!-- POLICKO PRE STUD. PROGRAMY ZAZNAMU TEXTU PODPROGRAMU A BUTTON PRE ICH VYBER -->
    <div *ngIf="appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)"
      [ngClass]="{'mb-5': !somPoslednaOpakovanaPolozka}">
      <app-studijne-programy-zaznamu
        [typZaznamuTextu]="typZaznamuTextu"
        [kodJazyk]="kodJazykIteracia"
        [poradiePolozkyVoFormulari]="indexPolozkyVoFormulari+1"
        [somPoslednaOpakovanaPolozka]="somPoslednaOpakovanaPolozka">
      </app-studijne-programy-zaznamu>
    </div>


  </div>

  <ng-template #neopakovanaPolozka>
    <div *ngIf="!typZaznamuTextu.idSkupina || typZaznamuTextu.idSkupina === 0;else skupinovaPolozka">

      <div *ngIf="typZaznamuTextu.uroven === 2
        && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
          class="text-warning" i18n>
          *položka je editovateľná len z úrovne fakulty
      </div>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label i18n>Zadajte text</mat-label>
        <input type="text"
              [placeholder]="getZadajteTextPlaceholder()"
              aria-label="Text"
              matInput
              [matAutocomplete]="auto"
              name="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
              id="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
              formControlName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
              autocomplete="disabled"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
          <button *ngIf="zobrazitClearButtonSK" type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="vymazObsahPolozky(kodJazykIteracia, indexPolozkyVoFormulari)"
              [matTooltip]="getZmazatTextTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of mapaFilteredOptionsVJazykoch.get(kodJazykIteracia) | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        <mat-hint i18n>min. 3 znaky pre filtrovanie položiek</mat-hint>
      </mat-form-field>

      <!-- pomocny text pre polozku podprogramu -->
      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
        class="ms-1 mb-3 font-italic">

        {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
      </div>

    </div>

    <!-- SKUPINOVE OPAKOVANIE -->
    <ng-template #skupinovaPolozka>
      <div formArrayName="name_{{typZaznamuTextu.idSkupina}}_{{kodJazykIteracia}}" class="mb-3">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label i18n>Zadajte text</mat-label>
          <input type="text"
               [placeholder]="getZadajteTextPlaceholder()"
                aria-label="Text"
                matInput
                [formControl]="mapaControlsovVJazykoch.get(kodJazykIteracia)"
                [matAutocomplete]="auto"
                name="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazykIteracia}}"
                id="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazykIteracia}}"
                [formControlName]="indexPolozkyVoFormulari"
                autocomplete="disabled">
            <button *ngIf="zobrazitClearButtonSK" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="vymazObsahPolozky(kodJazykIteracia, indexPolozkyVoFormulari)"
                [matTooltip]="getZmazatTextTooltip()"
                [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of mapaFilteredOptionsVJazykoch.get(kodJazykIteracia) | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          <mat-hint i18n>min. 3 znaky pre filtrovanie položiek</mat-hint>
        </mat-form-field>

        <!-- pomocny text pre polozku podprogramu -->
        <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
          class="ms-1 mb-3 font-italic">

          {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
        </div>

      </div>
    </ng-template>

  </ng-template>

</div>
